import React, { useState } from 'react';
import { graphql } from 'gatsby';

import { KontentStringValue } from '../../../types/KontentProps';
//@ts-ignore
import * as styles from './image-gallery.module.css';

type Image = {
    elements: {
        allow_download: {
            value: any;
        };
        caption?: {
            value: KontentStringValue;
        };
        image: {
            value: any[];
        };
    };
};

type ProductImages = {
    elements: {
        allow_download: {
            value: any;
        };
        caption?: {
            value: KontentStringValue;
        };
        file: {
            value: any[];
        };
    };
};

type Product = {
    elements: {
        gallery_images: {
            value: ProductImages[];
        };
    };
};
interface Props {
    display_type: any;
    images: {
        value: Image[];
    };
    product: {
        value: Product[];
    };
}

const ImageGallery: React.FC<Props> = ({ display_type, images, product }) => {
    const [zoomImage, setZoomImage] = useState({
        elements: {
            caption: {
                value: '',
            },
            allow_download: {
                value: [
                    {
                        codename: '',
                    },
                ],
            },
            file: {
                value: '',
            },
            image: {
                value: '',
            },
        },
    });
    const [zoomImageUrl, setZoomImageUrl] = useState('');
    const galleryImg = images.value;
    const productGalleryImg = product.value[0]?.elements.gallery_images.value;
    const displayType = display_type?.value[0]?.codename;
    const [showModal, setShowModal] = useState(false);

    const clickShowModal = (clickedImg: any) => {
        if (displayType !== 'use_product_images') {
            let fileNamePath = clickedImg.elements.image.value[0]?.url;

            setZoomImageUrl(fileNamePath);
        } else {
            let fileNamePath = clickedImg.elements.file.value[0]?.url;

            setZoomImageUrl(fileNamePath);
        }

        setZoomImage(clickedImg);
        setShowModal(true);
    };

    const renderImage = (image: Image, idx: number) => {
        return (
            <div className={styles.galleryImage} key={idx}>
                {image && (
                    <img
                        src={image.elements.image.value[0]?.url}
                        onClick={() => clickShowModal(image)}
                    />
                )}
                <span
                    className={styles.zoom}
                    onClick={() => clickShowModal(image)}
                ></span>
                <span className={styles.caption}>
                    {image.elements.caption?.value}
                </span>
                {image.elements.allow_download.value.length > 0 &&
                    image.elements.allow_download.value[0]?.codename ===
                        'yes' && (
                        <span className={styles.download}>
                            <a
                                href={image.elements?.image?.value[0]?.url}
                                target="_blank"
                            ></a>
                        </span>
                    )}
            </div>
        );
    };

    const renderProductImage = (
        productImage: ProductImages,
        productIdx: number
    ) => {
        return (
            <div className={styles.galleryImage} key={productIdx}>
                {productImage && (
                    <img
                        src={productImage.elements.file.value[0]?.url}
                        alt={productIdx.toString()}
                        onClick={() => clickShowModal(productImage)}
                    />
                )}
                <span
                    className={styles.zoom}
                    onClick={() => clickShowModal(productImage)}
                ></span>
                <span className={styles.caption}>
                    {productImage.elements.caption?.value}
                </span>
                {productImage.elements.allow_download.value.length > 0 &&
                    productImage.elements.allow_download.value[0]?.codename ===
                        'yes' && (
                        <span className={styles.download}>
                            <a
                                href={productImage.elements.file.value[0]?.url}
                                target="_blank"
                            ></a>
                        </span>
                    )}
            </div>
        );
    };

    return (
        <>
            <div className={styles.wrapper}>
                <div id={styles.gallery} className={styles.gallery}>
                    <div>
                        {displayType !== 'use_product_images' &&
                            galleryImg.map((Image: any, idx: any) => {
                                return renderImage(Image, idx);
                            })}
                        {displayType === 'use_product_images' &&
                            productGalleryImg?.map(
                                (ProductImage: any, idx: any) => {
                                    return renderProductImage(
                                        ProductImage,
                                        idx
                                    );
                                }
                            )}
                    </div>
                </div>
            </div>

            {showModal === true && (
                <div
                    className={styles.background}
                    onClick={() => setShowModal(false)}
                >
                    <div className={styles.modal}>
                        <div className={styles.wrapper}>
                            <img src={zoomImageUrl} />
                            <div className={styles.caption}>
                                <p>{zoomImage.elements.caption?.value}</p>
                                {zoomImage.elements.allow_download?.value
                                    .length > 0 &&
                                    zoomImage.elements.allow_download?.value[0]
                                        .codename === 'yes' && (
                                        <span className={styles.download}>
                                            <a
                                                href={zoomImageUrl}
                                                target="_blank"
                                            ></a>
                                        </span>
                                    )}
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default ImageGallery;

export const fragmentImageGallery = graphql`
    fragment ImageGallery on kontent_item_component___basic_image_gallery {
        elements {
            display_type {
                value {
                    codename
                }
            }
            images {
                value {
                    ... on kontent_item_media___gallery_image {
                        id
                        elements {
                            allow_download {
                                value {
                                    codename
                                }
                            }
                            caption {
                                value
                            }
                            image {
                                value {
                                    url
                                }
                            }
                        }
                    }
                }
            }
            product {
                value {
                    ... on kontent_item_component___product_specifications {
                        id
                        elements {
                            gallery_images {
                                value {
                                    ... on kontent_item_media___product_image {
                                        id
                                        elements {
                                            file {
                                                value {
                                                    url
                                                }
                                            }
                                            allow_download {
                                                value {
                                                    codename
                                                }
                                            }
                                            caption {
                                                value
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
`;
